/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { useEffect } from 'react';
import {
    useWizardContext,
    WizardProvider,
} from 'ui-interagency-pass/src/components/PassWizard/context/WizardContext';
import WizardModal from 'ui-interagency-pass/src/components/PassWizard/WizardModal';

import '../components/landingV2/index.scss';

function AutoOpenWizard() {
    const { openWizard, hideCloseButton } = useWizardContext();

    useEffect(() => {
        hideCloseButton();
        openWizard();
    }, [openWizard]);

    return <WizardModal shouldCloseOnOverlayClick={false} />;
}

function MobileWhichPassContainer() {
    const wizardFlags = {
        wizardEnabled: true,
        disclaimerEnabled: false,
    };

    return (
        <div className="new-pass-landing-page">
            <WizardProvider flags={wizardFlags}>
                <AutoOpenWizard />
            </WizardProvider>
        </div>
    );
}

export default MobileWhichPassContainer;
